import Crud from '../views/ChecklistExecution/Crud'
import View from '../views/ChecklistExecution/View'
import ChecklistView from '../views/Checklist/View'

let routes = {
    path: '/checklist-executions',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/checklist-executions',
            name: 'list-checklist-executions',
            component: Crud,
            meta: {
                pageTitle: 'Histórico de Checklists',
                breadcrumb: [
                    {
                        text: 'Histórico de Checklists',
                        active: true,
                    },
                ],
                perfil_id: ['1', '2', '6', '7'] // Perfis 1, 2 e 6 podem acessar
            },
        },
        {
            path: '/checklist-executions/retomar/:id',
            name: 'retomar-checklist-execution',
            component: ChecklistView,
            meta: {
                pageTitle: 'Retomar Checklist',
                breadcrumb: [
                    { text: 'Histórico de Checklists', to: '/checklist-executions' },
                    { text: 'Retomar', active: true },
                ],
                perfil_id: ['1', '2', '6', '7']
            },
        },
        {
            path: '/checklist-executions/view/:id',
            name: 'view-checklist-execution',
            component: View,
            meta: {
                pageTitle: 'Visualizar Execução',
                breadcrumb: [
                    {
                        text: 'Histórico de Checklists',
                        to: '/checklist-executions'
                    },
                    {
                        text: 'Visualizar',
                        active: true,
                    },
                ],
                perfil_id: ['1', '2', '6', '7'] // Perfis 1, 2 e 6 podem visualizar
            },
        },
    ]
};

export default routes